import { API } from "../../../utils";

export const getWebOrderFeeHistory = async () => {
  const res = await API.get(`web-order-fee/settings-history`);
  return res.data;
};

export const getWebOrderFeeSettings = async () => {
  const res = await API.get(`web-order-fee/settings`);
  return res.data;
};

export const updateWebOrderFeeSettings = async (payload) => {
  const res = await API.put(`web-order-fee/settings`, payload);
  return res.data;
};
